<!--视频轮播-->
<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6" :offset="0">
        <div style="border: 1px solid #c5d0e2; border-radius: 2px; padding: 16px">
          <!--车辆列表标题-->
          <div style="display: flex; align-items: center; font-size: 12px">
            <div style="color: #0f1a3a; font-weight: bold">
              {{ $t("videom.carousel_vehicle_list") }}
            </div>
            <div style="color: #0f1a3a; flex: 1; text-align: right">
              <span class="online"></span>
              {{ $t("vehicle.online") }}
              <span class="offline"></span>
              {{ $t("vehicle.offline") }}
            </div>
          </div>

          <!--车辆树-->
          <div style="
              border: 1px solid #a2b1cb;
              border-radius: 2px;
              padding: 8px;
              margin-top: 8px;
            ">
            <div>
              <el-input size="small" v-model="searchkey" :placeholder="$t('videom.plsinput')" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div style="
                margin-top: 8px;
                padding: 6px 4px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                font-size: 12px;
              ">
              <el-checkbox
                v-model="isSelectAll"
                :indeterminate="isSelectAllIndeterminate"
                :disabled="isCarouselRunning"
                size="mini"
                @change="handleSelectAllChange"
                style="margin-right: 16px"
              >
                {{ $t("public.selectAll") }}
              </el-checkbox>
              <el-checkbox
                v-model="onlyOnlineVehicles"
                :disabled="isCarouselRunning"
                size="mini"
                @change="handleOnlyOnlineChange"
              >
                {{ $t("videom.only_online_vehicles") }}
              </el-checkbox>
            </div>
            <div style="height: calc(100vh - 620px); min-height: 150px; overflow-y: auto">
              <el-tree
                :data="treedata"
                :props="defaultProps"
                :node-key="defaultNodeKey"
                ref="tree"
                highlight-current
                show-checkbox
                :filter-node-method="filterNode"
                @check="handleTreeCheck"
              >
                <div slot-scope="{ data }">
                  <div class="v_tree_node" :class="data.OnlineState != 0 ? 'v_online' : 'v_offline'">
                    <i class="icon_camera"></i>{{ data.CarNo }}
                  </div>
                </div>
              </el-tree>
            </div>
          </div>

          <!--通道选择-->
          <div style="margin-top: 12px">
            <div style="color: #0f1a3a; font-weight: bold; font-size: 12px; margin-bottom: 8px">
              {{ $t("videom.carousel_channel") }}
            </div>
            <el-radio-group v-model="selectedChannel" size="mini" :disabled="isCarouselRunning">
              <el-radio-button :label="1">1</el-radio-button>
              <el-radio-button :label="2">2</el-radio-button>
              <el-radio-button :label="3">3</el-radio-button>
              <el-radio-button :label="4">4</el-radio-button>
              <el-radio-button :label="5">5</el-radio-button>
              <el-radio-button :label="6">6</el-radio-button>
              <el-radio-button :label="7">7</el-radio-button>
              <el-radio-button :label="8">8</el-radio-button>
            </el-radio-group>
          </div>

          <!--轮播设置-->
          <div style="margin-top: 12px">
            <el-form label-width="110px" size="mini" label-position="left">
              <el-form-item :label="$t('videom.group_size')">
                <el-input-number v-model="groupSize" :min="1" :max="16" :disabled="isCarouselRunning"
                  size="mini" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('videom.carousel_interval')">
                <el-input-number v-model="carouselInterval" :min="20" :max="3600" :disabled="isCarouselRunning"
                  size="mini" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-form>
          </div>

          <!--轮播状态-->
          <div v-if="isCarouselRunning" style="
              margin-top: 12px;
              padding: 8px;
              background: #f0f9ff;
              border-radius: 4px;
              font-size: 12px;
            ">
            <div style="color: #2a7aff; font-weight: bold">
              {{ $t("videom.carousel_running") }}
            </div>
            <div style="margin-top: 4px; color: #0f1a3a">
              {{ $t("videom.current_group") }}：{{ currentGroupIndex + 1 }} /
              {{ groups.length }}
            </div>
            <div style="margin-top: 4px; color: #0f1a3a">
              {{ $t("videom.remaining_time") }}：{{ remainingTime }}
              {{ $t("videom.second") }}
            </div>
          </div>

          <!--操作按钮-->
          <div style="margin-top: 16px">
            <div class="btn_monitor" @click="startCarousel" v-if="!isCarouselRunning" style="margin-bottom: 8px">
              <i class="icon_start_monitor"></i>{{ $t("videom.start_carousel") }}
            </div>
            <div class="btn_monitor btn_stop" @click="stopCarousel" v-if="isCarouselRunning"
              style="margin-bottom: 8px">
              <i class="icon_stop_monitor"></i>{{ $t("videom.stop_carousel") }}
            </div>
            <div class="btn_monitor btn_reset" @click="resetConfig">
              {{ $t("videom.reset_config") }}
            </div>
          </div>
        </div>
      </el-col>

      <el-col :span="18" :offset="0">
        <div style="
            border: 1px solid #c5d0e2;
            border-radius: 2px;
            height: calc(100vh - 200px);
          ">
          <KLVideo :showToolBar="true" ref="klvideo" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import KLVideo from "@/components/KLVideo/index";
import { queryVideoDeviceNoByTime } from "@/http/vehicle";

export default {
  components: { KLVideo },

  watch: {
    searchkey(val) {
      this.$refs.tree.filter(val);
    },
    treedata() {
      this.updateSelectAllState();
    },
    //每组车辆数量变化时，同步切换右侧视频窗口布局（取最低符合数量）
    groupSize(val) {
      this.applyLayoutByGroupSize(val);
    },
  },

  computed: {
    defaultNodeKey() {
      return "DeviceNo";
    },
    isSelectAllIndeterminate() {
      var checked = this.getCheckedLeafNodes();
      var total = this.getSelectableLeafNodes();
      if (checked.length === 0) return false;
      return checked.length < total.length;
    },
  },

  data() {
    return {
      treedata: [],
      searchkey: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
      //全选相关
      isSelectAll: false,
      onlyOnlineVehicles: true,
      //轮播配置
      selectedChannel: 1,
      groupSize: 4,
      carouselInterval: 20,
      //轮播状态
      isCarouselRunning: false,
      groups: [],
      currentGroupIndex: 0,
      remainingTime: 0,
      //定时器
      carouselTimer: null,
      countdownTimer: null,
      openVideoTimer: null,
    };
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.CarNo.indexOf(value) !== -1;
    },

    //递归收集所有叶子节点（最末级车辆）
    collectLeafNodes(nodes, onlyOnline, list) {
      list = list || [];
      nodes = nodes || this.treedata;
      for (var i = 0; i < nodes.length; i++) {
        var item = nodes[i];
        var children = item[this.defaultProps.children];
        if (children && children.length > 0) {
          this.collectLeafNodes(children, onlyOnline, list);
        } else {
          //叶子节点需有 DeviceNo（或 CarNo）才被视为车辆
          if (item.DeviceNo !== undefined && item.DeviceNo !== null && item.DeviceNo !== "") {
            if (onlyOnline) {
              if (item.OnlineState != 0) {
                list.push(item);
              }
            } else {
              list.push(item);
            }
          }
        }
      }
      return list;
    },

    //获取所有可被全选的叶子节点（受 onlyOnlineVehicles 影响）
    getSelectableLeafNodes() {
      return this.collectLeafNodes(this.treedata, this.onlyOnlineVehicles, []);
    },

    //获取当前已勾选的叶子节点
    getCheckedLeafNodes() {
      if (!this.$refs.tree) return [];
      var checkedKeys = this.$refs.tree.getCheckedKeys() || [];
      var allLeaves = this.collectLeafNodes(this.treedata, false, []);
      return allLeaves.filter(function (n) {
        return checkedKeys.indexOf(n.DeviceNo) !== -1;
      });
    },

    //同步全选框状态（基于 checked 叶子数量与可选叶子数量）
    updateSelectAllState() {
      var selectable = this.getSelectableLeafNodes();
      var checked = this.getCheckedLeafNodes();
      //判断是否所有 selectable 都已被 checked
      if (selectable.length === 0) {
        this.isSelectAll = false;
        return;
      }
      var allChecked = selectable.every(
        function (n) {
          return checked.some(function (c) {
            return c.DeviceNo === n.DeviceNo;
          });
        }.bind(this)
      );
      this.isSelectAll = allChecked;
    },

    //树节点勾选变化时，同步更新全选状态
    handleTreeCheck() {
      this.$nextTick(function () {
        this.updateSelectAllState();
      });
    },

    //全选/取消全选
    handleSelectAllChange(val) {
      if (!this.$refs.tree) return;
      var selectable = this.getSelectableLeafNodes();
      var keys = selectable.map(function (n) {
        return n.DeviceNo;
      });
      if (val) {
        //勾选中的：当前手动勾选的 + 全选增加的（保留用户已勾选的其他项）
        var currentChecked = this.$refs.tree.getCheckedKeys() || [];
        var mergedKeys = currentChecked.slice();
        for (var i = 0; i < keys.length; i++) {
          if (mergedKeys.indexOf(keys[i]) === -1) {
            mergedKeys.push(keys[i]);
          }
        }
        this.$refs.tree.setCheckedKeys(mergedKeys);
        //若 onlyOnline=true，同时将离线节点从勾选列表中移除
        if (this.onlyOnlineVehicles) {
          var allLeaves = this.collectLeafNodes(this.treedata, false, []);
          var offlineKeys = allLeaves
            .filter(function (n) {
              return n.OnlineState == 0;
            })
            .map(function (n) {
              return n.DeviceNo;
            });
          var finalKeys = mergedKeys.filter(function (k) {
            return offlineKeys.indexOf(k) === -1;
          });
          this.$refs.tree.setCheckedKeys(finalKeys);
        }
      } else {
        //取消全选：移除全部可选项的 keys
        var currentKeys = this.$refs.tree.getCheckedKeys() || [];
        var remainKeys = currentKeys.filter(function (k) {
          return keys.indexOf(k) === -1;
        });
        this.$refs.tree.setCheckedKeys(remainKeys);
      }
      this.$nextTick(function () {
        this.updateSelectAllState();
      });
    },

    //切换只选在线车辆
    handleOnlyOnlineChange(val) {
      if (!this.$refs.tree) return;
      if (val) {
        //开启只选在线：把已勾选的离线节点取消勾选
        var currentKeys = this.$refs.tree.getCheckedKeys() || [];
        var allLeaves = this.collectLeafNodes(this.treedata, false, []);
        var offlineKeys = allLeaves
          .filter(function (n) {
            return n.OnlineState == 0;
          })
          .map(function (n) {
            return n.DeviceNo;
          });
        var newKeys = currentKeys.filter(function (k) {
          return offlineKeys.indexOf(k) === -1;
        });
        this.$refs.tree.setCheckedKeys(newKeys);
        //若之前是全选状态，则重新同步
        if (this.isSelectAll) {
          this.handleSelectAllChange(true);
        }
      } else {
        //关闭只选在线：若之前全选，则自动把离线也全选
        if (this.isSelectAll) {
          this.handleSelectAllChange(true);
        }
      }
      this.$nextTick(function () {
        this.updateSelectAllState();
      });
    },

    queryVideoDeviceNo() {
      //临时使用 queryVideoDeviceNoByTime 接口进行功能测试
      // queryVideoDeviceNoByTime({})
       this.$api.queryVideoDeviceNoByOptID().then((res) => {
        var data = (res && res.data) || [];
        //适配返回结构：该接口无 CarNo、OnlineState 字段，所有车辆均在线
        data.forEach(function (item) {
          if (!item.CarNo) {
            item.CarNo = item.ManufactureID || item.DeviceNo;
          }
          if (item.OnlineState === undefined || item.OnlineState === null) {
            item.OnlineState = 1;
          }
        });
        this.treedata = data;
      });
    },

    //根据数量获取合适的窗口布局
    getLayoutByCount(count) {
      if (count <= 1) return "box1";
      if (count <= 4) return "box4";
      if (count <= 6) return "box6";
      if (count <= 9) return "box9";
      if (count <= 10) return "box10";
      if (count <= 16) return "box16";
      if (count <= 25) return "box25";
      if (count <= 36) return "box36";
      if (count <= 48) return "box48";
      if (count <= 64) return "box64";
      return "box100";
    },

    //根据每组车辆数量切换右侧视频窗口布局（取大于等于该数量的最低符合布局）
    applyLayoutByGroupSize(size) {
      if (!this.$refs.klvideo) return;
      var layout = this.getLayoutByCount(size);
      this.$refs.klvideo.myLayout = layout;
    },

    //将车辆按每组大小分组
    splitIntoGroups(vehicles, size) {
      const groups = [];
      for (let i = 0; i < vehicles.length; i += size) {
        groups.push(vehicles.slice(i, i + size));
      }
      return groups;
    },

    //开始轮播
    startCarousel() {
      var v_list = this.$refs.tree.getCheckedNodes();
      if (v_list.length == 0) {
        this.$message({
          message: this.$t("videom.pls_select_carousel_vehicle"),
          type: "warning",
        });
        return;
      }
      if (!this.selectedChannel) {
        this.$message({
          message: this.$t("videom.pls_select_carousel_channel"),
          type: "warning",
        });
        return;
      }
      if (this.carouselInterval < 20) {
        this.$message({
          message: this.$t("videom.min_interval_warning"),
          type: "warning",
        });
        return;
      }

      this.groups = this.splitIntoGroups(v_list, this.groupSize);
      this.isCarouselRunning = true;
      this.currentGroupIndex = 0;
      this.playGroup(0);
    },

    //播放一组车辆视频
    playGroup(index) {
      this.clearTimers();

      //关闭所有当前播放
      this.$refs.klvideo.closeAllWnd();

      var group = this.groups[index];
      if (!group || group.length === 0) {
        this.nextGroup();
        return;
      }

      //设置窗口布局（按每组车辆数量取最低符合布局）
      this.applyLayoutByGroupSize(this.groupSize);

      //逐个打开视频（错开500ms避免并发压力）
      var vIndex = 0;
      var channel = this.selectedChannel;
      this.openVideoTimer = setInterval(() => {
        if (vIndex < group.length) {
          this.$refs.klvideo.SetWait(
            group[vIndex].DeviceNo,
            parseInt(channel),
            group[vIndex].CarNo
          );
          vIndex++;
        } else {
          //所有视频打开完成后，启动轮播定时器
          clearInterval(this.openVideoTimer);
          this.openVideoTimer = null;

          this.remainingTime = this.carouselInterval;

          //倒计时
          this.countdownTimer = setInterval(() => {
            this.remainingTime--;
            if (this.remainingTime <= 0) {
              clearInterval(this.countdownTimer);
              this.countdownTimer = null;
            }
          }, 1000);

          //到时间切换到下一组
          this.carouselTimer = setTimeout(() => {
            this.nextGroup();
          }, this.carouselInterval * 1000);
        }
      }, 500);
    },

    //切换到下一组
    nextGroup() {
      this.currentGroupIndex = (this.currentGroupIndex + 1) % this.groups.length;
      this.playGroup(this.currentGroupIndex);
    },

    //停止轮播
    stopCarousel() {
      this.clearTimers();
      if (this.$refs.klvideo) {
        this.$refs.klvideo.closeAllWnd();
      }
      this.isCarouselRunning = false;
      this.currentGroupIndex = 0;
      this.remainingTime = 0;
      this.$message({
        message: this.$t("videom.carousel_stopped"),
        type: "info",
      });
    },

    //重置配置
    resetConfig() {
      this.stopCarousel();
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedKeys([]);
      }
      this.selectedChannel = 1;
      this.groupSize = 4;
      this.carouselInterval = 20;
    },

    //清除所有定时器
    clearTimers() {
      if (this.carouselTimer) {
        clearTimeout(this.carouselTimer);
        this.carouselTimer = null;
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      if (this.openVideoTimer) {
        clearInterval(this.openVideoTimer);
        this.openVideoTimer = null;
      }
    },
  },

  mounted() {
    this.queryVideoDeviceNo();
    //页面加载后按默认每组车辆数量初始化右侧窗口布局
    this.$nextTick(() => {
      this.applyLayoutByGroupSize(this.groupSize);
    });
  },

  beforeDestroy() {
    this.clearTimers();
    if (this.$refs.klvideo) {
      this.$refs.klvideo.closeAllWnd();
    }
  },
};
</script>
<style scoped>
.btn_monitor {
  display: flex;
  align-items: center;
  background: #2a7aff;
  border-radius: 2px;
  height: 32px;
  font-size: 12px;
  color: #ffffff;
  flex-direction: row;
  justify-content: center;
  cursor: pointer;
}

.btn_monitor.btn_stop {
  background: #f56c6c;
}

.btn_monitor.btn_reset {
  background: #909399;
}

.v_tree_node {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.v_tree_node>i {
  width: 16px;
  height: 16px;
  margin-right: 4px;
  background-size: cover;
  display: inline-block;
}

.v_online {
  color: #0F1A3A;
}

.v_offline {
  color: #A2B1CB;
}

.offline {
  background: #A2B1CB !important;
  width: 10px;
  height: 10px;
  display: inline-block;
}

.online {
  background: #0F1A3A !important;
  width: 10px;
  height: 10px;
  display: inline-block;
}

.v_offline>.icon_camera {
  background-image: url("@/assets/images/icon_shexiangtou_hui.png");
}

.v_online>.icon_camera {
  background-image: url("@/assets/images/icon_shexiangtou_hei.png");
}

.icon_start_monitor {
  width: 20px;
  height: 20px;
  margin-right: 4px;
  display: inline-block;
  background-image: url("@/assets/images/icon_kaishijiankong.png");
}

.icon_stop_monitor {
  width: 20px;
  height: 20px;
  margin-right: 4px;
  display: inline-block;
  background-image: url("@/assets/images/icon_jieshujiankong.png");
}

.el-radio-button {
  margin-right: 0 !important;
}
</style>
